import { createActions, createReducer } from 'reduxsauce';
import Immutable from 'seamless-immutable';

export const { Types, Creators } = createActions({
	// Actions Saga
	dadoParametrizadoBuscarPorAlertaId: ['alertaId', 'callback'],

	// Actions reducers
	dadoParametrizadoBuscarPorAlertaIdReducer: ['dadoParametrizado'],
});

export const INITIAL_STATE_VALUES = {
	responsavel: '',
	dataAcao: undefined,
	responsavelEmissao: '',
	dataHoraEmissao: undefined,
	dadoParametrizado: {
		alertaId: 0,
		categoria: {
			id: 0,
		},
		confianca: {
			id: 0,
		},
		danosPossiveis: '',
		id: 0,
		periodo: undefined,
		dataInicial: undefined,
		horaInicial: undefined,
		dataOcorrencia: undefined,
		horaOcorrencia: undefined,
		informacoes: '',
		iniciador: {
			id: 0,
		},
		planoContigencia: '',
		severidade: {
			id: 0,
		},
		urgencia: {
			id: 0,
		},
	},
	lista: {},
};

const INITIAL_STATE = Immutable(Object.assign({}, INITIAL_STATE_VALUES));

const dadoParametrizadoBuscarPorAlertaIdReducer = (state = INITIAL_STATE, action) => state.merge({
	responsavel: action.data.responsavel,
	dataAcao: action.data.dataAcao,
	responsavelEmissao: action.data.responsavelEmissao,
	dataHoraEmissao: action.data.dataHoraEmissao,
	dadoParametrizado: { ...action.dadoParametrizado },
});

export default createReducer(INITIAL_STATE, {
	[Types.DADO_PARAMETRIZADO_BUSCAR_POR_ALERTA_ID_REDUCER]:
		dadoParametrizadoBuscarPorAlertaIdReducer,
});
